<template>
  <div>
    <b-container
      fluid
      class="bg-top-inicio mb-md-2 px-0 d-block d-lg-block no-print"
    >
      <b-container>
        <b-row class="ml-0">
          <!-- logo mineduc-->
          <div class="logo col-3 pl-0 mr-auto">
            <a href="https://www.mineduc.cl/" target="_blank">
              <img
                class="img-fluid pr-lg-4"
                src="@/assets/img/logo-tope-subesup-mineduc3.png"
                alt="Ministerio de Educación"
              />
            </a>
          </div>
          <!-- logo mineduc-->
          <!-- Logo ACCESO Texto DESCKTOP-->
          <b-container class="text-center mt-n4 ml-5 d-none d-md-block">
            <router-link :to="{ name: 'Home' }">
              <img
                src="@/assets/img/logo_acceso2.svg"
                class="logo-acceso img-fluid"
                alt="logo ACCESO a la Educación Superior"
              />
            </router-link>
          </b-container>
          <!-- Logo ACCESO Texto DESCKTOP-->
        </b-row>
        <!--MENU HEADER DESKTOP-->
        <div
          class="container row justify-content-between position-relative d-none d-md-block"
        >
          <nav class="navbar row segundo mt-1 mt-lg-3 py-0">
            <ul class="navbar-nav col-auto mr-auto">
              <li class="nav-item col-11 py-2 py-lg-0 mr-2 mr-lg-4">
                <b-dropdown
                  variant="transparent"
                  dropright
                  class="d-flex flex-row"
                  menu-class="atp"
                  toggle-tag="div"
                  toggle-class="text-uppercase border-left atp py-2 pl-3 mb-1"
                >
                  <template v-slot:button-content>
                    Admisión
                    <br />Técnico&nbsp;Profesional
                  </template>
                  <b-dropdown-item :to="{ name: 'AdmisionTP' }"
                    >Admisión</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item :to="{ name: 'FCU' }">FCU</b-dropdown-item>
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item @click="irInstituciones"
                    >Instituciones TP</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item @click="irCarreras"
                    >Carreras 2025</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item @click="irComparadorITP"
                    >Comparador</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item :to="{ name: 'ReglamentoTP' }"
                    >Normativa</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item :to="{ name: 'CalendarioTP' }"
                    >Calendario</b-dropdown-item
                  >
                </b-dropdown>
              </li>
            </ul>
          </nav>
          <nav class="navbar row tercero py-0">
            <ul class="navbar-nav col-auto mr-auto">
              <li class="nav-item col-11 py-2 py-lg-0 mr-2 mr-lg-3">
                <b-dropdown
                  variant="transparent"
                  dropright
                  class="d-flex flex-row"
                  menu-class="au"
                  toggle-tag="div"
                  toggle-class="text-uppercase au py-2 pl-3 mb-1"
                >
                  <template v-slot:button-content>
                    Admisión
                    <br />Universitaria
                  </template>
                  <b-dropdown-item @click="irInstUniver"
                    >Instituciones</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item @click="irCarrerasUniver"
                    >Buscador de Carreras 2025</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <!--<b-dropdown-item>Comparador</b-dropdown-item>
                  <b-dropdown-divider tag="div"></b-dropdown-divider>-->
                  <b-dropdown-item :to="{ name: 'ReglamentoU' }"
                    >Normativa</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <b-dropdown-item :to="{ name: 'CalendarioU' }"
                    >Calendario</b-dropdown-item
                  >
                  <b-dropdown-divider tag="div"></b-dropdown-divider>
                  <!--<b-dropdown-item :to="{ name: 'AdmisionU' }"
                    >Admisión Universidades</b-dropdown-item
                  >-->
                  <b-dropdown-item
                    :to="{ name: 'MaterialPreparacionU' }"
                    style="padding: 0 !important"
                    >PAES Regular</b-dropdown-item
                  >
                </b-dropdown>
              </li>
            </ul>
          </nav>

          <div class="container display-inline">
            <div class="social">
              <ul class="col pr-md-0">
                <li class>
                  <a href="https://twitter.com/SubseEdSuperior" target="_blank">
                    <i class="fab fa-twitter"></i>
                  </a>
                </li>
                <li class>
                  <a
                    href="https://www.facebook.com/SubseEdSuperior"
                    target="_blank"
                  >
                    <i class="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li class>
                  <a
                    href="https://www.instagram.com/subseedsuperior/"
                    target="_blank"
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--MENU HEADER DESKTOP-->
      </b-container>

      <div class="container-fluid mx-0 d-block d-md-none mov">
        <!-- Header mov -->
        <header class="container px-0">
          <div class="row d-inline-flex mt-n2 w-100 position-relative ml-0">
            <!-- navbar mov -->

            <nav
              class="navbar navbar-expand-lg col d-block d-md-none"
              @click="mostrar"
            >
              <button
                id="menu-toggle"
                class="navbar-toggler btn btn-primary"
                type="button"
              >
                <span>
                  <i class="fas fa-bars btn-brand"></i>
                </span>
              </button>
              <MenuContenido />
            </nav>
          </div>
        </header>
      </div>
      <div class="container d-block d-md-none">
        <router-link :to="{ name: 'Home' }">
          <img
            src="@/assets/img/logo_acceso2.svg"
            class="logo-acceso img-fluid"
            alt="logo ACCESO a la Educación Superior"
          />
        </router-link>
      </div>
    </b-container>

    <!--NAV -->
    <div class="container-fluid bg-nav mx-0 dkt d-none d-md-block no-print">
      <!-- Header desktop -->
      <header class="container px-0 position-relative">
        <div class="row d-inline-flex mt-n2 w-100">
          <!-- navbar desktop -->
          <nav class="navbar navbar-expand-lg col align-top d-flex">
            <router-link
              :to="{ name: 'Home' }"
              class="home mt-3 ml-4 pl-0 d-inline"
            >
              <i class="fas fa-home"></i>
            </router-link>
            <button
              class="navbar-toggler btn-azul-oscuro mr-3 mr-lg-5"
              type="button"
              data-toggle="collapse"
              data-target="#collapse_target1"
              aria-controls="navbarToggler"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon">
                <i class="fas fa-bars btn-brand"></i>
              </span>
            </button>

            <nav
              class="navbar row primero collapse navbar-collapse d-flex justify-content-end col-10 ml-auto mr-0 mt-0"
              id="collapse_target1"
            >
              <ul class="navbar-nav pr-0">
                <!--Sistema-->
                <li class="nav-item sacc col-auto text-right py-2 py-lg-0 px-1">
                  <b-dropdown
                    id="dropdown-1"
                    text="Sistema de Acceso"
                    variant="transparent"
                    menu-class="sacc mb-1"
                    toggle-tag="a"
                    toggle-class="sacc"
                  >
                    <b-dropdown-item :to="{ name: 'Sistema' }"
                      >Sistema</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'Comite' }"
                      >Comités de Acceso</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'Instituciones' }"
                      >Instituciones</b-dropdown-item
                    >
                  </b-dropdown>
                </li>
                <!--Sistema-->
                <li class="nav-item col-auto text-right mt-1 py-2 py-lg-0 px-1">
                  |
                </li>
                <!--Admisión Universidades-->
                <li
                  class="nav-item sacc col-auto text-right py-2 py-lg-0 pr-0 pl-1"
                >
                  <b-dropdown
                    id="dropdown-2"
                    text="Admisión Universidades"
                    variant="transparent"
                    menu-class="sacc mb-1"
                    toggle-tag="a"
                    toggle-class="sacc"
                  >
                    <b-dropdown-item :to="{ name: 'AdmisionRegular' }"
                      >Admisión Regular</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'CuposBea' }"
                      >Cupos BEA</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'MasMujeresCientificas' }"
                      >Cupos Más Mujeres Científicas</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'AdmisionEspecial' }"
                      >Admisión Especial</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'PaesInvierno' }"
                      >PAES Invierno</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'PaesRegular' }"
                      >PAES Regular</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'PortalPegagias' }"
                      >Portal Pedagogías</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'PortalExtranjeros' }"
                      >Portal Personas Extranjeras</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'DistincionesTrayectorias' }"
                      >Distinciones a las Trayectorias
                      Educativas</b-dropdown-item
                    >
                  </b-dropdown>
                </li>
                <!--Admisión Universidades-->
                <li class="nav-item col-auto text-right mt-1 py-2 py-lg-0 px-1">
                  |
                </li>
                <!--Programas de Acceso-->
                <li class="nav-item col-auto text-right py-2 py-lg-0 px-1">
                  <b-dropdown
                    id="dropdown-2"
                    text="Programas de Acceso"
                    variant="transparent"
                    menu-class="sacc mb-1"
                    toggle-tag="a"
                    toggle-class="sacc"
                  >
                    <b-dropdown-item :to="{ name: 'PortalPace' }"
                      >Programa PACE</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'ProgramaPedagogias' }"
                      >Programa Acceso a Pedagogías</b-dropdown-item
                    >
                  </b-dropdown>
                </li>
                <!--Programas de Acceso-->

                <li class="nav-item col-auto text-right mt-1 py-2 py-lg-0 px-1">
                  |
                </li>
                <!--Beneficios Estudiantiles-->
                <li class="nav-item col-auto text-right py-2 py-lg-0 px-1">
                  <router-link
                    class="text-nowrap btn"
                    :to="{ name: 'BeneficiosEstudiantiles' }"
                    >Beneficios Estudiantiles</router-link
                  >
                </li>
                <!--Beneficios Estudiantiles-->
                <li class="nav-item col-auto text-right mt-1 py-2 py-lg-0 px-1">
                  |
                </li>
                <!--Preguntas Frecuentes-->
                <li class="nav-item col-auto text-right py-2 py-lg-0 pl-2">
                  <b-dropdown
                    id="dropdown-1"
                    text="Preguntas Frecuentes"
                    variant="transparent"
                    menu-class="sacc mb-1"
                    toggle-tag="a"
                    toggle-class="sacc"
                  >
                    <b-dropdown-item :to="{ name: 'PreguntasAdmisionTP' }"
                      >Admision Técnico Profesional</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'PreguntasAdmisionU' }"
                      >Admisión Universidades</b-dropdown-item
                    >
                    <b-dropdown-item :to="{ name: 'PreguntasInformacionPAES' }"
                      >Información General PAES
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'PreguntasPedagogias' }"
                      >Admisión Pedagogías
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'PreguntasProgramaPACE' }"
                      >Programas PACE
                    </b-dropdown-item>
                    <b-dropdown-item :to="{ name: 'PreguntasSistemaAcceso' }"
                      >Sistema de Acceso</b-dropdown-item
                    >
                  </b-dropdown>
                </li>
                <!--Preguntas Frecuentes-->
              </ul>
            </nav>
          </nav>
        </div>
      </header>
    </div>
    <!-- -->
  </div>
</template>
<script>
import MenuContenido from "@/components/generales/MenuSidebar";
import { mapActions } from "vuex";
export default {
  name: "Header",
  components: {
    MenuContenido
  },
  data() {
    return {
      mostrarToggle: false
    };
  },
  methods: {
    ...mapActions(["setBusqueda", "setSimulacion"]),
    mostrar() {
      this.mostrarToggle = !this.mostrarToggle;
      this.$emit("mostrarToggle", this.mostrarToggle);
    },
    irInstituciones() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorIP" });
    },
    irCarreras() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorTP" });
    },
    irCarrerasUniver() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorCU" });
    },
    irInstUniver() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "BuscadorInstU" });
    },
    irSimulador() {
      this.limpiarBusquedasAplicadas();
      this.limpiarDataSimulacion();
      this.$router.push({ name: "SimuladorPonderaciones" });
    },
    irComparadorITP() {
      this.limpiarBusquedasAplicadas();
      this.$router.push({ name: "ComparadorITP" });
    },
    limpiarBusquedasAplicadas() {
      this.setBusqueda([]);
    },
    limpiarDataSimulacion() {
      this.setSimulacion({});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wrapper/Header.vue